const e = ["size xs", "size s", "size m", "size l", "size xl", "size xxl"], r = (s) => s.sort(
  (o, i) => e.indexOf(o.offer?.scopedProduct?.size?.toLowerCase()) - e.indexOf(i.offer?.scopedProduct?.size?.toLowerCase())
);
export {
  r as sortSizes,
  e as sortingArray
};
